module.exports = __webpack_public_path__ + "img/tariff-selection-bg--1199.b903686.webp";